import { render, staticRenderFns } from "./vehicle.vue?vue&type=template&id=a36097c8&scoped=true&"
import script from "./vehicle.vue?vue&type=script&lang=js&"
export * from "./vehicle.vue?vue&type=script&lang=js&"
import style0 from "./vehicle.vue?vue&type=style&index=0&id=a36097c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36097c8",
  null
  
)

export default component.exports